// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		paginationType: bcSfFilterConfig.custom.coll_infiniscroll ? 'infinite' : 'default',
	}
};

var bcSfFilterTemplate = {
	'saleClass': 'on-sale',
	'soldOutClass': 'sold-out',
	'blockLayoutClass': 'ft ftw ft-nm',

	'saleLabelHtml': '<span class="product-label product-label--sale"><span>' + bcSfFilterConfig.label.sale + '</span></span>',
	'soldOutLabelHtml': '<span class="product-label product-label--soldout"><span>' + bcSfFilterConfig.label.soldout + '</span></span>',

	// Grid Template
	'productGridItemHtml':  '<div class="product-block {{soldOutClass}} flex column {{maxColsClass}} min-cols-2 {{itemGridWidthClass}}">' +
								'<div class="image {{imageHoverClass}}">' +
									'<div class="inner">' +
										'<a href="{{itemUrl}}">' +
											'{{itemImg}}' +
										'</a>' +
										'{{itemQuickView}}' +
									'</div>' +
									'{{itemLabels}}' +
								'</div>' +

								'<div class="{{blockLayoutClass}}">' +
									'<div class="ftr">' +
										'<a class="title ftc" href="{{itemUrl}}">{{itemTitle}}{{itemVendor}}</a>' +
										'<div class="price ftc {{saleClass}}">{{itemPrice}}</div>' +
									'</div>' +
								'</div>' +
								'<div class="themed-product-reviews">' +
									'<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
								'</div>' +
							'</div>',

	// Pagination Template
	'previousActiveHtml': '<li><a href="{{itemUrl}}" class="prev"><i class="icon-arrow-left"></i></a></li>',
	'previousDisabledHtml': '<li><span class="linkless prev"><i class="icon-arrow-left"></i></span></li>',
	'nextActiveHtml': '<li><a href="{{itemUrl}}" class="next"><i class="icon-arrow-right"></i></a></li>',
	'nextDisabledHtml': '<li><span class="linkless next"><i class="icon-arrow-right"></i></span></li>',
	'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li class="active"><span class="linkless">{{itemTitle}}</span></li>',
	'pageItemRemainHtml': '<li><span class="linkless">{{itemTitle}}</span></li>',
	'paginateHtml': '<ul class="pagination">{{previous}}{{pageItems}}{{next}}</ul>',

	// Sorting Template
	'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + ':</label><div class="pretty-select id-sort-by"><select class="sort-by">{{sortingItems}}</select><span class="text"><span class="value">{{itemLabelActive}}</span></span><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path><path d="M0-.75h24v24H0z" fill="none"></path></svg></div>',
};

BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
	/*** Prepare data ***/
	var images = data.images_info;
	 // Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/

	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	// Add soldOut class
	var soldOutClass = soldOut && bcSfFilterConfig.custom.label_soldout_enable ? bcSfFilterTemplate.soldOutClass : '';
	itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

	// Add maxColsClass
	itemHtml = itemHtml.replace(/{{maxColsClass}}/g, 'max-cols-' + bcSfFilterConfig.custom.products_per_row);

	// Add itemGridWidthClass
	var itemGridWidthClass = ''
	if (index % 2 == 1) { itemGridWidthClass += 'nth-2 '; }
	if (index % 3 == 1) { itemGridWidthClass += 'nth-3 '; }
	if (index % 4 == 1) { itemGridWidthClass += 'nth-4 '; }
	if (index % 6 == 1) { itemGridWidthClass += 'nth-6 '; }
	itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

	// Add Block layout class
	var blockLayoutClass = bcSfFilterConfig.custom.block_layout == 'beside' ? bcSfFilterTemplate.blockLayoutClass : '';
	itemHtml = itemHtml.replace(/{{blockLayoutClass}}/g, blockLayoutClass);

	// Add image hover class
	var imageHoverClass = bcSfFilterConfig.custom.product_grid_hover_image && images.length > 1 ? 'image--with-secondary' : '';
	itemHtml = itemHtml.replace(/{{imageHoverClass}}/g, imageHoverClass);

	// Add price
	var itemPriceHtml = '';
	var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
	if (priceVaries) {
		itemPriceHtml += bcSfFilterConfig.label.from_price + ' ';
	}
	itemPriceHtml += '<span class="amount theme-money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
	if (onSale) {
		itemPriceHtml += ' <del><span class="theme-money">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span></del>';
	}
	itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add vendor
	itemVendorHtml = bcSfFilterConfig.custom.grid_show_vendor ? '<div class="vendor">'+ data.vendor +'</div>' : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

	// Add Labels
	var itemLabelsHtml = '';
	if (onSale && bcSfFilterConfig.custom.label_sale_enable) {
		itemLabelsHtml += bcSfFilterTemplate.saleLabelHtml;
	} else if (bcSfFilterConfig.custom.label_remain_show && data.variants.length == 1 && data.variants[0].inventory_quantity > 0 && data.variants[0].inventory_quantity <= bcSfFilterConfig.custom.prod_stock_warn_limit) {
		itemLabelsHtml += '<span class="product-label general"><span>' + bcSfFilterConfig.label.only_x_left.replace(/{{ quantity }}/g, data.variants[0]['inventory_quantity']) + '</span></span>';
	} else {
		if (soldOut && bcSfFilterConfig.custom.label_soldout_enable) {
			itemLabelsHtml += bcSfFilterTemplate.soldOutLabelHtml;
		} else {
			for (var k in data.tags) {
				var tag = data['tags'][k];
				if (tag.indexOf('meta-label-') > -1) {
					itemLabelsHtml += '<span class="product-label general"><span>' + tag.replace('meta-label-', '') + '</span></span>';
				}
			}
		}
	}
	itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

	// Add Quickview
	var itemQuickViewHtml = '';
	if (bcSfFilterConfig.custom.prod_quick_buy_show) {
		itemQuickViewHtml += '<div class="quick-buy-wrap pos-' + bcSfFilterConfig.custom.prod_quick_buy_pos + '">';
		itemQuickViewHtml += '<a class="quick-buy ';
		itemQuickViewHtml += bcSfFilterConfig.custom.prod_quick_buy_pos == 'middle' ? 'giant' : 'big';
		itemQuickViewHtml += '-round-button" href="{{itemUrl}}"><span>' + bcSfFilterConfig.label.quick_view + '</span></a>';
		itemQuickViewHtml += '</div>';
	}
	itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

	//Add Image
	var itemImgHtml = '';
	var aspectRatio = images.length > 0 ? images[0].width / images[0].height : 1;
	var maxWidth = images.length > 0 ? images[0].width : 480;
	itemImgHtml += '<div class="image__primary">' +
						'<div class="rimage-outer-wrapper" style="max-width:' + maxWidth + 'px">' +
							'<div class="rimage-wrapper lazyload--placeholder" style="padding-top:' + 1 / aspectRatio * 100 + '%">' +
								'<img class="rimage__image lazyload fade-in" data-src="' + this.getFeaturedImage(images, '{width}x') + '" ' + 
									'data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' + aspectRatio + '" ' +
									'data-sizes="auto" alt="{{itemTitle}}"' +
								'/>' +
							'</div>' +
						'</div>'+
					'</div>';
	if (bcSfFilterConfig.custom.product_grid_hover_image && images.length > 1) {
		itemImgHtml += '<div class="image__secondary"><img src="' + images[1].src + '" alt="{{itemTitle}}" /></div>' ;
	}
	itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml);

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	return itemHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  
	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}

	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		jQ(this.selector.pagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content 
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			html = html.replace(/{{itemLabelActive}}/g, sortingArr[this.queryParams.sort]);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function() {
	// load content for Quick view	
	if (bcSfFilterConfig.custom.prod_quick_buy_show){
		jQ('.product-block').each(function() {
			var _this = this;
			var url = jQ(this).find("a").eq(0).attr("href");
			jQ.ajax({
				type: "GET",
				url: url + '?view=bc-sf-quickview',
				success: function(data){
					if (jQ(_this).find('.quickbuy-placeholder-template').length == 0){
						jQ(_this).find('.inner').append(data);
					}
				}
			});
		})
	}
	if (window.SPR) {
		SPR.initDomEls();
		SPR.loadBadges();
	}

	// Init multi currency
	if (bcSfFilterConfig.custom.show_multiple_currencies) {
		if (window.theme && typeof theme.runMultiCurrency == 'function'){
			theme.runMultiCurrency();
		}		
	}

	// Match height image
	if (window.$ && typeof $('#bc-sf-filter-products').imagesLoaded  == 'function'){
		$('#bc-sf-filter-products').imagesLoaded(function(){
			$(window).trigger('normheights');
		});
	}
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
	// Display number of products
	jQ('.results-count').html(bcSfFilterConfig.label.products_count.replace(/{{ count }}/g, data.total_product));
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
